import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="min-h-screen" data-testid="refund-policy-page">
      <Header onBookClick={() => {}} />
      
      <main className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="mb-8">
            <Link to="/" className="text-sky-600 hover:underline text-sm">
              ← Back to Home
            </Link>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8">
            Refund Policy
          </h1>
          
          <p className="text-slate-500 mb-8">Last Updated: December 2025</p>
          
          <div className="legal-content">
            <p>
              At Nova Shelf, customer satisfaction is our priority. This Refund Policy 
              outlines the circumstances under which refunds may be issued for our 
              cleaning services.
            </p>

            <h2>Our Satisfaction Commitment</h2>
            <p>
              We stand behind the quality of our cleaning services. If you are not 
              satisfied with any aspect of our service, please contact us within 24 
              hours of service completion, and we will work to resolve your concerns.
            </p>

            <h2>Re-Cleaning Policy</h2>
            <p>
              If you are dissatisfied with any area of our cleaning, we offer a 
              complimentary re-clean of the affected areas, subject to the following 
              conditions:
            </p>
            <ul>
              <li>The concern must be reported within 24 hours of service completion</li>
              <li>The issue must relate to services included in the original booking</li>
              <li>The re-clean will be scheduled at a mutually convenient time</li>
              <li>The re-clean service is limited to areas covered in the original service</li>
            </ul>

            <h2>Refund Eligibility</h2>
            <p>Refunds may be considered in the following circumstances:</p>
            <ul>
              <li>Service was not performed as agreed upon</li>
              <li>Nova Shelf cancels a scheduled service without adequate notice</li>
              <li>Quality concerns that cannot be resolved through re-cleaning</li>
            </ul>

            <h2>Refund Exclusions</h2>
            <p>Refunds will generally not be provided for:</p>
            <ul>
              <li>Services that have been satisfactorily completed</li>
              <li>Complaints reported more than 24 hours after service completion</li>
              <li>Issues unrelated to the cleaning service provided</li>
              <li>Customer-caused obstacles that prevented complete service delivery</li>
              <li>Pre-existing conditions or damage</li>
            </ul>

            <h2>Cancellation Refunds</h2>
            <h3>Customer Cancellations</h3>
            <ul>
              <li>24+ hours notice: Full refund of any prepayment</li>
              <li>Less than 24 hours notice: Cancellation fee may apply</li>
            </ul>
            <h3>Nova Shelf Cancellations</h3>
            <p>
              If we must cancel a scheduled service, you will receive a full refund 
              of any prepayment and priority rebooking at your convenience.
            </p>

            <h2>How to Request a Refund</h2>
            <p>To request a refund or discuss concerns:</p>
            <ol>
              <li>Contact us within 24 hours of service completion</li>
              <li>Provide your booking details and description of the issue</li>
              <li>Include photos if applicable</li>
              <li>Our team will review your request and respond within 48 hours</li>
            </ol>

            <h2>Refund Processing</h2>
            <p>
              Approved refunds will be processed within 5-10 business days using the 
              original payment method. The timing of the refund appearing in your 
              account may vary based on your financial institution.
            </p>

            <h2>Disputes</h2>
            <p>
              If you disagree with our decision regarding a refund request, you may 
              request a review by our management team. We are committed to fair 
              resolution of all customer concerns.
            </p>

            <h2>Contact Us</h2>
            <p>For refund requests or questions about this policy:</p>
            <ul>
              <li>Email: support@novashelf.store</li>
              <li>Phone: +1-888-453-2345</li>
              <li>Address: 1587 Magnolia Court, Houston, TX 77002</li>
            </ul>

            <h2>Policy Updates</h2>
            <p>
              We reserve the right to modify this Refund Policy at any time. Changes 
              will be effective upon posting to our website.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPolicy;
